import styled from 'styled-components';

export const ItemContainer = styled.div`
  color: red;
  position: relative;
  margin: 0 12px 12px 0;

  button {
    padding-right: 20px;
  }
`;
